/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { InjectionToken } from '@angular/core'

export const LOCALISATION_BASE_URL = new InjectionToken<string>('localisationBasePath')
export const API_KEY = new InjectionToken<string>('profileApiKey')

export const BackendRoutes = {
  CONFIG_BASE: 'configuration/:version/:stage/:country/:locale.json',

  PROFILE: 'profiles/mydata',

  FORM__SCHEMA__SIGNUP: 'schemas/:version/signup-:type/:country/:locale.json',
  FORM__LAYOUT__SIGNUP: 'layouts/:version/signup-:type/:country.json',

  v1: {
    PUBLIC__LEGAL: 'public/v2/:country/:locale/legal',
    PUBLIC__KEYS_PASSWORD: 'public/v1/:country/:locale/keys/password',
    PUBLIC__KEYS_SPIN: 'public/v1/:country/:language/keys/spin',
    PUBLIC__KEYS_PASSWORD_ENCRYPT: 'public/v1/:country/:locale/keys/password/encrypt',
    PUBLIC__ORGANISATION: 'public/v1/:country/:locale/organisation',
    PUBLIC__ORGANISATION__CONTACT_CENTER: 'public/v1/:country/:locale/organisation?orgCountry=:country&orgFunction=contact_centre',
    PUBLIC__FEATURE_ALL: 'public/v1/:country/:locale/features',
    PUBLIC__FEATURE: 'public/v1/:country/:locale/features/:feature',

    REGISTRATION__INVITE: 'registration/v1/:country/:locale/invite',
    REGISTRATION__TRANSACTION: 'registration/v1/:country/:locale/transaction',
    REGISTRATION__ACTION_RESEND: 'registration/v1/:country/:locale/action/resend',
    REGISTRATION__ACTION_SECURE_RESEND: 'registration/v1/:country/:locale/action/secure-resend',
    REGISTRATION__REGISTER_ORGANISATION: 'registration/v1/:country/:locale/register/organisation',
    CONFIRMATION__CONFIRM: 'confirmation/v1/:country/:locale/confirm',
    CONFIRMATION__SECURE_CONFIRM: 'confirmation/v1/:country/:locale/secure-confirm',
    CONFIRMATION__AUTH: 'confirmation/v1/:country/:locale/auth',
    CONFIRMATION__SECURE_AUTH: 'confirmation/v1/:country/:locale/secure-auth',
    CONFIRMATION__OTP_REQUEST: 'confirmation/v1/:country/:locale/otp/request',
    CONFIRMATION__OTP_VERIFICATION: 'confirmation/v1/:country/:locale/otp/verification',
    CONFIRMATION__INTERNAL_STATE_MACHINE: 'confirmation/v1/:country/:locale/otp/smscode/help',
    CONFIRMATION__SPIN: 'confirmation/v1/:country/:locale/spin',
    CONFIRMATION__TRANSACTION_ID: 'confirmation/v1/:country/:locale/transaction-id',

    SHORT_LINK__RESOLVE: 'v1/links/:shortLinkId',
  },
  v2: {
    CONFIRMATION__SPIN: 'confirmation/v2/:country/:locale/spin',
  },
}
